module.exports = __webpack_public_path__ + "static/babbel-426c7b490e9cef90160287d19e85ad4c.png";